/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { ReactNode } from 'react';

import { Container } from '@/primitives/Container';
import './ContentContainer.css';

export type ContentContainerProps = {
  width?: string;
  children: ReactNode;
  className?: string;
};

export function ContentContainer({ width, children, className }: ContentContainerProps) {
  const containerClassName = className ? `mimic-container ${className}` : 'mimic-container';
  return (
    <Container horizontal className={containerClassName}>
      <div style={{ width: width || '1024px' }}>{children}</div>
    </Container>
  );
}
